import $ from "jquery"

export function promoPopupBanner () {
  $(document).ready( () => {
      $(".promo-banner-close").click(function() {
        console.log("click")
          $(this).parent().remove()
      })
  })
}
